import { CommandInterface } from './CommandIntervalWorker';

export class FuncCommand implements CommandInterface {
    constructor(private readonly cb: (...args) => Promise<any>) {}

    execute(...args): Promise<any> {
        return this.cb(...args);
    }
}
